import { xhr } from 'utils/xhr'

const API_BASE = '/cfos'

const getCfos = () =>
  xhr.get(API_BASE)

export { getCfos }
